import { AuthService, FCMService } from '@/api'
import { useAppStore } from '@/store'
import SuspenceLoader from '@/ui/suspence_loader'
import { ACTIVE_CURRENCY, getFCMToken, queryClient, tryOnce } from '@/utils'
import { useQuery } from '@tanstack/react-query'
import { Suspense, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { ModuleAuthenticator } from '../hooks'
import AuthModule from './auth'
import NativeAuthRedirect from './auth/native_auth_redirect'
import Dashbaord from './dashboard'
import SetupPasskey from './dashboard/setup-passkey'
import SetupUsername from './dashboard/setup-username'
import Home from './home'
import SubmitReferralCode from './dashboard/submit-referral-code'
import ServerConnectionErrorScreen from './server_connection_error'
import { popup } from '@/popup_handler'
import { CreateWalletScreen } from './dashboard/home/create_wallet'
//@ts-ignore
const pusherBindGlobal = (event: string, data: any) => {
  switch (event) {
    case 'PAYMENT_REQUEST':
      return queryClient.invalidateQueries(['recentActivity'])
    case 'TRANSACTION':
      queryClient.invalidateQueries(['notifications'])
      return queryClient.invalidateQueries(['transactions'])
  }
}
const AppRouter = () => {
  const { loadWallets, resetWallets, wallets, is_loading } = useAppStore((state) => state) as any
  const user = useQuery(['user'], () => AuthService.Status())
  const IS_PASSKEY_SETUP = window.localStorage.getItem(`passkey:${user.data?._id}`) === 'true' ? true : false
  useEffect(() => {
    if (!user || !user.data?._id || !(window as any).pusher) return
    var channel = (window as any).pusher.subscribe(user.data._id)
    channel.bind_global(pusherBindGlobal)
    return () => {
      ;(window as any).pusher.unsubscribe(user.data._id)
      channel.unbind()
    }
  }, [user])
  useEffect(() => {
    try {
      if (!user.data) {
        resetWallets()
      } else {
        loadWallets()
        if ('Notification' in window) {
          if (Notification.permission === 'granted') {
            getFCMToken()
              .then((token: any) => {
                FCMService.SYNC(token)
              })
              .catch(console.log)
          } else if (Notification.permission !== 'denied') {
            setTimeout(() => {
              tryOnce(
                'notificationPermission',
                () =>
                  popup.open('information', {
                    title: "Don't miss out!",
                    description: 'Please Allow us to send you notifications',
                    icon: () => (
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-16 fill-gray-500" viewBox="0 -960 960 960" width="24px">
                        <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z" />
                      </svg>
                    ),
                    onConfirm: () => {
                      getFCMToken()
                        .then((token: any) => {
                          FCMService.SYNC(token)
                        })
                        .catch(console.log)
                    },
                  }),
                3,
                'day'
              )
            }, 1000)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }, [user.data])
  useEffect(() => {
    if (!user.data) return
    ACTIVE_CURRENCY.conversion_rate = user.data.default_currency.conversion_rate
    ACTIVE_CURRENCY.currency = user.data.default_currency.name
    ACTIVE_CURRENCY.symbol = user.data.default_currency.symbol
  }, [user.data])
  if (user.data) {
    if (!user.data.username) {
      return <SetupUsername username={user.data.username} name={user.data.name} default_chain={user.data.default_chain} default_currency={user.data.default_currency.name} />
    } else if (user.data?.rewardProfile?.submittedReferralCode === false && user.data?.rewardProfile?.skippedReferralCode !== true) {
      return <SubmitReferralCode />
    } else if (!IS_PASSKEY_SETUP) {
      return <SetupPasskey />
    } else if (wallets !== null && !wallets.length && !is_loading) {
      return <CreateWalletScreen />
    }
  }
  if (user.status === 'error') {
    return <ServerConnectionErrorScreen />
  }
  return (
    <ModuleAuthenticator user={user.data}>
      <Suspense
        fallback={
          <SuspenceLoader
            children={
              <>
                <h2 className="">Hey there! 👋</h2>
                <h5 className="">We're just setting the stage.</h5>
                <p className=""> Please hold on while we get everything ready...</p>
              </>
            }
            loader={<div className="loader-line "></div>}
          />
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth" element={<AuthModule />} />
          <Route path="/dashboard/*" element={<Dashbaord />}>
            <Route index element={<Dashbaord />} />
          </Route>
          <Route path="/native-auth" element={<NativeAuthRedirect />} />
        </Routes>
      </Suspense>
    </ModuleAuthenticator>
  )
}
export default AppRouter
